"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const is_prop_valid_1 = __importDefault(require("@emotion/is-prop-valid"));
const styled_1 = __importDefault(require("@emotion/styled"));
const DividerRoot = (0, styled_1.default)('hr', {
    shouldForwardProp: (prop) => (0, is_prop_valid_1.default)(prop) && prop !== 'orientation'
})({
    margin: 0,
    borderWidth: 0,
    borderStyle: 'solid'
}, ({ orientation, theme, children }) => ({
    borderColor: theme.palette.colors.azureish,
    ...(orientation === 'horizontal' && {
        borderBottomWidth: 1,
        width: '100%'
    }),
    ...(orientation === 'vertical' && {
        borderRightWidth: 1,
        height: 'auto'
    }),
    ...(children && {
        'display': 'flex',
        'border': 0,
        ...(orientation === 'vertical' && {
            flexDirection: 'column'
        }),
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center',
            ...(orientation === 'horizontal' && {
                width: '100%',
                borderTopWidth: 1,
                borderTopStyle: 'solid',
                borderColor: theme.palette.colors.azureish
            }),
            ...(orientation === 'vertical' && {
                height: '100%',
                borderLeftWidth: 1,
                borderLeftStyle: 'solid',
                borderColor: theme.palette.colors.azureish
            })
        }
    })
}));
exports.default = DividerRoot;
//# sourceMappingURL=DividerRoot.js.map